module.exports = __webpack_public_path__ + "img/ONE_platforms_logo.4aeacfb6.gif";